import { useState, useEffect } from 'react'
import { isPurMode } from '@/utils/app/paid'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'

export function useIsPurMode(cookies: RequestCookie[]) {
  const [purMode, setPurMode] = useState(false)
  console.log('Checking PUR mode with cookies:', cookies)
  useEffect(() => {
    if (isPurMode(cookies)) setPurMode(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return purMode
}
